// src/pages/PleaseSignInPage.js
import React from 'react';
import { Lock } from 'lucide-react';

function PleaseSignInPage({ onSignIn, featureName = "this feature" }) {
  return (
    <div className="flex-grow flex flex-col items-center justify-center text-center p-8 animate-fade-in">
      <div className="bg-slate-800/50 backdrop-blur-md p-8 md:p-12 rounded-3xl shadow-2xl w-full max-w-md border border-slate-700/50">
        <div className="flex justify-center mb-6">
          <div className="bg-indigo-500/20 p-6 rounded-full">
            <Lock size={48} className="text-indigo-400" />
          </div>
        </div>

        <h2 className="text-3xl font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 to-cyan-400">
          Authentication Required
        </h2>

        <p className="text-gray-300 mb-8 text-lg">
          Please sign in to access <span className="text-indigo-400 font-semibold">{featureName}</span>
        </p>

        <button
          onClick={() => {
            if (typeof onSignIn === 'function') {
              onSignIn();
            }
          }}
          className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white font-semibold py-4 px-6 rounded-xl shadow-lg shadow-indigo-500/30 transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-indigo-500/50 flex items-center justify-center space-x-3"
        >
          <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
            <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
            <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
            <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
            <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571l0.001-0.001l6.19,5.238C39.712,34.464,44,29.865,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
          </svg>
          <span className="text-lg">Sign In with Google</span>
        </button>

        <p className="text-gray-500 text-sm mt-6">
          Secure authentication powered by Google
        </p>
      </div>
    </div>
  );
}

export default PleaseSignInPage;